/* eslint-disable */
import { useEffect, useState } from "react";
import { HashRouter as Router, Routes, Route, Link, Navigate, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  ScrollText,
  MessageSquare,
  Landmark,
  UserCircle2,
  Settings as SettingsIcon,
  Home as HomeIcon,
  BookUser,
  Crown,
  Building2,
  HardHat,
  Shield,
  Activity,
  QrCode,
  Wallet,
  UserCheck,
  CalendarDays,
  Car,
  ShoppingBag,
  PartyPopper,
  Dumbbell,
} from "lucide-react";
import "./styles/main.css";
import Documents from "./documents";
import MemberDocuments from "./documents_module/MemberDocuments";
import Home from "./home";
import Footer from "./footer";
import LoginModal from "./auth/LoginModal";
import RegisterModal from "./auth/RegisterModal";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import AdminDashboard from "./admin/AdminDashboard";
import AdminHome from "./admin/AdminHome";
import MembersList from "./members/MembersList";
import PaymentsPage from "./payments/PaymentsPage";
import ProfilePage from "./profile/ProfilePage";
import AppShell from "./shell/AppShell";
import OnboardingVilla from "./onboarding/OnboardingVilla";
import NotificationsPage from "./notifications/NotificationsPage";
import DirectoryPage from "./directory/DirectoryPage";
import ContactDetail from "./directory/ContactDetail";
import ContactForm from "./directory/ContactForm";
import AdminDirectoryPage from "./directory/AdminDirectoryPage";
import BoardPage from "./board/BoardPage";
import RolePage from "./board/RolePage";
import OperationsPage from "./operations/OperationsPage";
import AuditPage from "./admin/AuditPage";
import PageViewTracker from "./audit/PageViewTracker";
import SettingsPage from "./settings/SettingsPage";
import SupervisorMap from "./security/SupervisorMap";
import SecurityPage from "./security/SecurityPage";
import PropertiesBrowse from "./properties/PropertiesBrowse";
import PropertyDetail from "./properties/PropertyDetail";
import CarpoolsPage from "./carpools/CarpoolsPage";
import CarpoolDetail from "./carpools/CarpoolDetail";
import EventsPage from "./events/EventsPage";
import EventDetail from "./events/EventDetail";
import EventForm from "./events/EventForm";
import GoodsPage from "./goods/GoodsPage";
import GoodsDetail from "./goods/GoodsDetail";
import GoodsForm from "./goods/GoodsForm";
import HostedEventForm from "./hosted-events/HostedEventForm";
import HostedEventDetail from "./hosted-events/HostedEventDetail";
import VisitorCheckInPage from "./visitors/VisitorCheckInPage";
import UnsubscribePage from "./unsubscribe/UnsubscribePage";
import AmenitiesPage from "./amenities/AmenitiesPage";
import SosPanel from "./sos/SosPanel";
import CreateListing from "./properties/CreateListing";
import EditListing from "./properties/EditListing";
import MyListings from "./properties/MyListings";
import SavedProperties from "./properties/SavedProperties";
import VillaPage from "./villa/VillaPage";
import GovernancePage from "./governance/GovernancePage";
import IssueDetailPage from "./governance/IssueDetailPage";
import MeetingDetailPage from "./governance/MeetingDetailPage";
import DiscussionsPage from "./discussions/DiscussionsPage";
import VisitorApprovalPage from "./visitors/VisitorApprovalPage";
import GatePage from "./visitors/GatePage";
import VisitorOpsPage from "./security/VisitorOpsPage";
import TopicThreadPage from "./discussions/TopicThreadPage";
import ReportQueue from "./discussions/ReportQueue";
import ApprovalPendingPage from "./approval/ApprovalPendingPage";
import { apiFetch } from "./auth/apiClient";
import { Toast as UIToast } from "./ui";
import DesignDocs from "./ui/__designdocs__/DesignDocs.jsx";

const ADMIN_NAV = [
  { key: "dashboard", label: "Dashboard", Icon: LayoutDashboard, to: "/", match: (p) => p === "/", iconBg: "#FFEDD5", iconColor: "#EA580C" },
  { key: "residents",   label: "Residents",   Icon: Users,           to: "/residents",  iconBg: "#E0E7FF", iconColor: "#4F46E5" },
  { key: "board",     label: "Board",     Icon: Crown,           to: "/board", iconBg: "#FEF3C7", iconColor: "#B45309" },
  { key: "operations", label: "Operations", Icon: HardHat,        to: "/operations", iconBg: "#FEE2E2", iconColor: "#B91C1C" },
  { key: "security",   label: "Security",   Icon: Shield,          to: "/security", iconBg: "#DCFCE7", iconColor: "#166534" },
  { key: "properties", label: "Properties", Icon: Building2,      to: "/properties", iconBg: "#DCFCE7", iconColor: "#1B5E20" },  // brand-color-ok
  { key: "payments",  label: "Payments",  Icon: Wallet,          to: "/payments", iconBg: "#FEF9C3", iconColor: "#A16207" },
  { key: "directory", label: "Directory", Icon: BookUser,        to: "/directory", iconBg: "#FEF3C7", iconColor: "#D97706" },
  { key: "documents", label: "Documents", Icon: ScrollText,      to: "/documents", iconBg: "#EDE9FE", iconColor: "#7C3AED" },
  { key: "audit",     label: "Audit",     Icon: Activity,        to: "/admin/audit", iconBg: "#FEE2E2", iconColor: "#B91C1C" },
  { key: "discussions", label: "Discussions", Icon: MessageSquare, to: "/discussions", iconBg: "#DCFCE7", iconColor: "#16A34A" },
  { key: "governance", label: "Governance", Icon: Landmark,       to: "/governance", iconBg: "#FEF3C7", iconColor: "#D97706" },
  { key: "marketplace", label: "Marketplace", Icon: ShoppingBag, to: "/goods",      iconBg: "#F0FDF4", iconColor: "#16A34A" },
  { key: "events",    label: "Events",    Icon: CalendarDays, to: "/events",  iconBg: "#FDF4FF", iconColor: "#9333EA" },
  { key: "carpools",  label: "Carpool",   Icon: Car,        to: "/carpools", iconBg: "#E0F2FE", iconColor: "#0369A1" },
  { key: "amenities",  label: "Clubhouse",   Icon: Dumbbell,    to: "/amenities", iconBg: "#DCFCE7", iconColor: "#15803D" },
  { key: "profile",   label: "Profile",   Icon: UserCircle2,     to: "/profile", iconBg: "#DBEAFE", iconColor: "#2563EB" },
  { key: "settings",  label: "Settings",  Icon: SettingsIcon,    to: "/settings", iconBg: "#F8FAFC", iconColor: "#64748B" },
];

const USER_NAV = [
  { key: "home",      label: "Home",      Icon: HomeIcon,    to: "/", match: (p) => p === "/", iconBg: "#FFEDD5", iconColor: "#EA580C" },
  { key: "gate",      label: "Gate",      Icon: QrCode,      to: "/visitors", iconBg: "#DBEAFE", iconColor: "#2563EB" },
  { key: "board",     label: "Board",     Icon: Crown,       to: "/board", iconBg: "#FEF3C7", iconColor: "#B45309" },
  { key: "discussions", label: "Discussions", Icon: MessageSquare, to: "/discussions", iconBg: "#DCFCE7", iconColor: "#16A34A" },
  { key: "governance", label: "Governance", Icon: Landmark,  to: "/governance", iconBg: "#FEF3C7", iconColor: "#D97706" },
  { key: "operations", label: "Operations", Icon: HardHat,   to: "/operations", iconBg: "#FEE2E2", iconColor: "#B91C1C" },
  { key: "properties", label: "Properties", Icon: Building2, to: "/properties", iconBg: "#DCFCE7", iconColor: "#1B5E20" },  // brand-color-ok
  { key: "events",    label: "Events",    Icon: CalendarDays, to: "/events",  iconBg: "#FDF4FF", iconColor: "#9333EA" },
  { key: "hosted-events", label: "My Events", Icon: PartyPopper, to: "/hosted-events", iconBg: "#FCE7F3", iconColor: "#DB2777" },
  { key: "marketplace", label: "Marketplace", Icon: ShoppingBag, to: "/goods", iconBg: "#F0FDF4", iconColor: "#16A34A" },
  { key: "amenities",  label: "Clubhouse",   Icon: Dumbbell,   to: "/amenities", iconBg: "#DCFCE7", iconColor: "#15803D" },
  { key: "carpools",  label: "Carpool",   Icon: Car,        to: "/carpools", iconBg: "#E0F2FE", iconColor: "#0369A1" },
  { key: "payments",  label: "Payments",  Icon: Wallet,     to: "/payments", iconBg: "#FEF9C3", iconColor: "#A16207" },
  { key: "documents", label: "Documents", Icon: ScrollText,  to: "/documents", iconBg: "#EDE9FE", iconColor: "#7C3AED" },
  { key: "directory", label: "Directory", Icon: BookUser,    to: "/directory", iconBg: "#FEF3C7", iconColor: "#D97706" },
  { key: "residents",   label: "Residents",   Icon: Users,       to: "/residents",  iconBg: "#E0E7FF", iconColor: "#4F46E5" },
  { key: "profile",   label: "Profile",   Icon: UserCircle2, to: "/profile", iconBg: "#DBEAFE", iconColor: "#2563EB" },
  { key: "settings",  label: "Settings",  Icon: SettingsIcon, to: "/settings", iconBg: "#F8FAFC", iconColor: "#64748B" },
];

// Facility Manager — runs operations + the gate, sits outside the community.
// No payments / governance / documents / pass-creation / discussions.
const FM_NAV = [
  { key: "dashboard", label: "Dashboard", Icon: LayoutDashboard, to: "/", match: (p) => p === "/", iconBg: "#FFEDD5", iconColor: "#EA580C" },
  { key: "gate",       label: "Visitor Approval", Icon: UserCheck, to: "/gate", iconBg: "#DBEAFE", iconColor: "#2563EB" },
  { key: "operations", label: "Operations", Icon: HardHat,       to: "/operations", iconBg: "#FEE2E2", iconColor: "#B91C1C" },
  { key: "residents",    label: "Residents",    Icon: Users,         to: "/residents",  iconBg: "#E0E7FF", iconColor: "#4F46E5" },
  { key: "properties", label: "Properties", Icon: Building2,     to: "/properties", iconBg: "#DCFCE7", iconColor: "#1B5E20" },  // brand-color-ok
  { key: "board",      label: "Board",      Icon: Crown,         to: "/board", iconBg: "#FEF3C7", iconColor: "#B45309" },
  { key: "profile",    label: "Profile",    Icon: UserCircle2,   to: "/profile", iconBg: "#DBEAFE", iconColor: "#2563EB" },
  { key: "settings",   label: "Settings",   Icon: SettingsIcon,  to: "/settings", iconBg: "#F8FAFC", iconColor: "#64748B" },
];

// Security Incharge — supervises the gate + guards. Adds visitor approval and
// the guard live-location map; tickets only when the FM assigns them.
const INCHARGE_NAV = [
  { key: "dashboard", label: "Dashboard", Icon: LayoutDashboard, to: "/", match: (p) => p === "/", iconBg: "#FFEDD5", iconColor: "#EA580C" },
  { key: "gate",       label: "Visitor Approval", Icon: UserCheck, to: "/gate", iconBg: "#DBEAFE", iconColor: "#2563EB" },
  { key: "security",   label: "Security",   Icon: Shield,        to: "/security", iconBg: "#DCFCE7", iconColor: "#166534" },
  { key: "operations", label: "Operations", Icon: HardHat,       to: "/operations", iconBg: "#FEE2E2", iconColor: "#B91C1C" },
  { key: "residents",    label: "Residents",    Icon: Users,         to: "/residents",  iconBg: "#E0E7FF", iconColor: "#4F46E5" },
  { key: "properties", label: "Properties", Icon: Building2,     to: "/properties", iconBg: "#DCFCE7", iconColor: "#1B5E20" },  // brand-color-ok
  { key: "board",      label: "Board",      Icon: Crown,         to: "/board", iconBg: "#FEF3C7", iconColor: "#B45309" },
  { key: "profile",    label: "Profile",    Icon: UserCircle2,   to: "/profile", iconBg: "#DBEAFE", iconColor: "#2563EB" },
  { key: "settings",   label: "Settings",   Icon: SettingsIcon,  to: "/settings", iconBg: "#F8FAFC", iconColor: "#64748B" },
];

// Guards / workers / visitors are outside users who only ever touch their own
// profile on the web (their real surface is the mobile app).
const STAFF_NAV = [
  { key: "profile", label: "Profile", Icon: UserCircle2, to: "/profile", match: (p) => p === "/" || p === "/profile", iconBg: "#DBEAFE", iconColor: "#2563EB" },
];

// app_roles that mean "outside-community staff" — used to skip the resident
// villa-onboarding gate (they have no villa) and to pick the right shell.
const OUTSIDE_STAFF_ROLES = [
  "FACILITY_MANAGER",
  "SECURITY_INCHARGE",
  "SECURITY_GUARD",
  "SERVICE_STAFF",
  "CLUBHOUSE_SECURITY",
];

function AdminAwareDirectory() {
  // Admins see browse by default but can jump to /admin/directory from
  // their dashboard. This wrapper keeps /directory consistent for
  // everyone.
  return <DirectoryPage />;
}

function MembersPage() {
  return (
    <div>
      <div className="vsa-page-head">
        <div>
          <h1>Residents</h1>
          <p className="vsa-page-subtitle">All registered residents grouped by villa</p>
        </div>
      </div>
      <MembersList canApprove={false} />
    </div>
  );
}

function AuthErrorBanner() {
  const [msg, setMsg] = useState(() => sessionStorage.getItem("auth_error") || "");
  useEffect(() => {
    const onErr = () => setMsg(sessionStorage.getItem("auth_error") || "");
    window.addEventListener("vs_auth_error", onErr);
    return () => window.removeEventListener("vs_auth_error", onErr);
  }, []);
  if (!msg) return null;
  return (
    <div className="vs-auth-banner">
      <span>⚠ {msg}</span>
      <button
        onClick={() => {
          sessionStorage.removeItem("auth_error");
          setMsg("");
        }}
      >
        Dismiss
      </button>
    </div>
  );
}

// Pick the membership the approval-pending takeover should describe: an
// active PENDING request wins, then REJECTED (re-requestable), then REVOKED.
function pickPendingMembership(memberships) {
  const order = ["PENDING", "REJECTED", "REVOKED"];
  for (const status of order) {
    const m = memberships.find((x) => x.approval_status === status);
    if (m) return m;
  }
  return memberships[0] || null;
}

function AuthenticatedTree({ user, onLogout }) {
  // null = still checking; true = needs to pick a villa; false = good to go
  const [needsOnboarding, setNeedsOnboarding] = useState(null);
  const [onboardingDone, setOnboardingDone] = useState(false);
  // Live /api/users/me payload — memberships[] carries approval_status plus
  // the pending-screen context (requested_at, last_reminded_at,
  // rejection_reason, approval_contact) for unapproved own memberships.
  const [me, setMe] = useState(null);
  // Trust /api/users/me as the source of truth for admin status so that
  // mid-session promotions/demotions take effect on the next page load
  // without forcing the user to log out and log back in.
  const [isAdmin, setIsAdmin] = useState(!!user.is_admin);
  // Admin tier (SUPER_ADMIN / IT_ADMIN / board role). Document approvals are
  // restricted to true admins, so board members never see that affordance.
  const [adminRole, setAdminRole] = useState(user.admin_role || null);
  // The role the session is currently acting as. An admin who has switched
  // into their resident view holds the admin role (`isAdmin`) but should see
  // the resident shell — so admin surfaces gate on `isAdminView`, not the
  // raw capability. The backend enforces the same scope via the signed token.
  const { activeRole, availableRoles } = useAuth();
  const isAdminView = isAdmin && activeRole === "ADMIN";
  // Outside-community staff shells (FM / incharge / locked guard-worker view).
  const isFMView = !isAdmin && activeRole === "FACILITY_MANAGER";
  const isInchargeView = !isAdmin && activeRole === "SECURITY_INCHARGE";
  const isLockedStaffView =
    !isAdmin &&
    ["SECURITY_GUARD", "SERVICE_STAFF", "CLUBHOUSE_SECURITY"].includes(
      activeRole
    );
  // Only SUPER/IT admins may approve documents (not board members, who also
  // carry is_admin). Gated further by being in the admin view.
  const canApprove =
    isAdminView && ["SUPER_ADMIN", "IT_ADMIN"].includes(adminRole);

  const check = () => {
    apiFetch("/api/users/me", { authRequired: true })
      .then((d) => {
        // Every *resident* — including admins and board members — belongs
        // to a villa. Outside-community staff (FM / incharge / guards /
        // workers) have no villa and must skip the onboarding gate entirely.
        const hasVilla = (d.memberships || []).length > 0;
        const isOutsideStaff = (d.app_roles || []).some((r) =>
          OUTSIDE_STAFF_ROLES.includes(r)
        );
        setNeedsOnboarding(!hasVilla && !isOutsideStaff);
        setMe(d);
        const liveIsAdmin = !!d.is_admin;
        setIsAdmin(liveIsAdmin);
        setAdminRole(d.admin_role || null);
        // Keep the cached user blob in sync so reloads pick up the new flag.
        if (liveIsAdmin !== !!user.is_admin) {
          try {
            const cached = JSON.parse(localStorage.getItem("user") || "{}");
            localStorage.setItem(
              "user",
              JSON.stringify({ ...cached, is_admin: liveIsAdmin })
            );
          } catch (_) {}
        }
      })
      .catch(() => setNeedsOnboarding(false));
  };

  useEffect(() => {
    check();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  if (needsOnboarding === null) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", color: "#64748b" }}>
        Loading…
      </div>
    );
  }

  if (needsOnboarding && !onboardingDone) {
    return (
      <OnboardingVilla
        userName={user.name}
        onSubmitted={() => {
          setOnboardingDone(true);
          // Recheck so we move past the gate.
          check();
        }}
        onLogout={onLogout}
      />
    );
  }

  // Approval-pending takeover (docs/specs/approval-pending-screen.md): a
  // plain community member whose membership isn't APPROVED yet is effectively
  // a non-user — show one purposeful full-page screen instead of a shell full
  // of 403s. Admins and outside-community staff (FM / incharge / guards /
  // workers) keep their role shells regardless of villa memberships.
  const liveMemberships = (me && me.memberships) || [];
  const liveIsOutsideStaff = ((me && me.app_roles) || []).some((r) =>
    OUTSIDE_STAFF_ROLES.includes(r)
  );
  const hasApprovedMembership = liveMemberships.some(
    (m) => m.approval_status === "APPROVED"
  );
  if (
    me &&
    !isAdmin &&
    !liveIsOutsideStaff &&
    liveMemberships.length > 0 &&
    !hasApprovedMembership
  ) {
    return (
      <ApprovalPendingPage
        membership={pickPendingMembership(liveMemberships)}
        onLogout={onLogout}
      />
    );
  }

  const view = isAdminView
    ? "admin"
    : isFMView
    ? "fm"
    : isInchargeView
    ? "incharge"
    : isLockedStaffView
    ? "staff"
    : "resident";
  const navItems = {
    admin: ADMIN_NAV,
    fm: FM_NAV,
    incharge: INCHARGE_NAV,
    staff: STAFF_NAV,
    resident: USER_NAV,
  }[view];

  return (
    <ShellRoutes
      user={{ ...user, is_admin: isAdminView }}
      navItems={navItems}
      onLogout={onLogout}
      isAdmin={isAdminView}
      canApprove={canApprove}
      view={view}
    />
  );
}

function ShellRoutes({ user, navItems, onLogout, isAdmin, canApprove, view }) {
  const isFM = view === "fm";
  const isIncharge = view === "incharge";
  const isStaff = view === "staff"; // guard / worker / visitor — profile only
  // Outside-community staff (FM + incharge) never see resident-community
  // surfaces: payments, governance, documents, discussions, directory or
  // resident pass-creation. Defense-in-depth — the backend refuses too.
  const isOutsideStaff = isFM || isIncharge || isStaff;
  // The gate (visitor approval) console: admins, the FM and the incharge.
  const canGate = isAdmin || isFM || isIncharge;
  // Guard live-location map: admins and the incharge.
  const canSeeSecurity = isAdmin || isIncharge;

  // Locked staff (guard/worker/visitor): only their own profile + settings.
  if (isStaff) {
    return (
      <AppShell user={user} navItems={navItems} onLogout={onLogout}>
        <AuthErrorBanner />
        <Routes>
          <Route path="/__designdocs__" element={<DesignDocs />} />
          <Route path="/" element={<ProfilePage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AppShell>
    );
  }

  return (
    <AppShell user={user} navItems={navItems} onLogout={onLogout}>
      <AuthErrorBanner />
      <Routes>
        <Route path="/__designdocs__" element={<DesignDocs />} />
        <Route path="/" element={isAdmin ? <AdminHome user={user} /> : <ShellHome isResident={!isOutsideStaff} />} />
        <Route path="/downloads" element={<Documents heading="Downloads" />} />
        <Route
          path="/documents"
          element={isOutsideStaff ? <NotFound /> : <DocumentsPage isAdmin={isAdmin} canApprove={canApprove} />}
        />
        <Route path="/residents" element={isAdmin ? <AdminDashboard canApprove={canApprove} /> : <MembersPage />} />
        {/* Back-compat: old "/members" deep links (e.g. historical notifications) redirect to Residents. */}
        <Route path="/members" element={<Navigate to="/residents" replace />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/profile/:userId" element={<ProfilePage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/gate" element={canGate ? <VisitorApprovalPage /> : <NotFound />} />
        <Route path="/visitors" element={isOutsideStaff ? <NotFound /> : <GatePage />} />
        <Route path="/daily-help" element={isOutsideStaff ? <NotFound /> : <GatePage />} />
        <Route path="/directory" element={isOutsideStaff ? <NotFound /> : (isAdmin ? <AdminAwareDirectory /> : <DirectoryPage />)} />
        <Route path="/directory/new" element={<ContactForm mode="create" />} />
        <Route path="/directory/contact/:id" element={<ContactDetail />} />
        <Route path="/directory/contact/:id/edit" element={<ContactForm mode="edit" />} />
        <Route path="/admin/directory" element={<AdminDirectoryPage />} />
        <Route path="/admin/audit" element={<AuditPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/board" element={<BoardPage />} />
        <Route path="/board/roles/:role" element={<RolePage />} />
        <Route path="/governance" element={isOutsideStaff ? <NotFound /> : <GovernancePage />} />
        <Route path="/governance/issues/:id" element={isOutsideStaff ? <NotFound /> : <IssueDetailPage />} />
        <Route path="/governance/meetings/:id" element={isOutsideStaff ? <NotFound /> : <MeetingDetailPage />} />
        <Route path="/discussions" element={isOutsideStaff ? <NotFound /> : <DiscussionsPage />} />
        <Route
          path="/discussions/reports"
          element={isAdmin ? <ReportQueue /> : <NotFound />}
        />
        <Route path="/discussions/topics/:id" element={isOutsideStaff ? <NotFound /> : <TopicThreadPage isAdmin={isAdmin} />} />
        <Route path="/operations" element={<OperationsPage />} />
        <Route
          path="/security"
          element={canSeeSecurity ? <SecurityPage isAdmin={isAdmin} /> : <NotFound />}
        />
        <Route
          path="/security/visitors"
          element={canSeeSecurity || isFMView ? <VisitorOpsPage /> : <NotFound />}
        />
        <Route path="/properties" element={<PropertiesBrowse />} />
        <Route path="/properties/new" element={<CreateListing />} />
        <Route path="/properties/me" element={<MyListings />} />
        <Route path="/properties/saved" element={<SavedProperties />} />
        <Route path="/properties/:id" element={<PropertyDetail />} />
        <Route path="/properties/:id/edit" element={<EditListing />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/new" element={<EventForm />} />
        <Route path="/events/:id" element={<EventDetail />} />
        <Route path="/events/:id/edit" element={<EventForm />} />
        <Route path="/carpools" element={<CarpoolsPage />} />
        <Route path="/carpools/:id" element={<CarpoolDetail />} />
        <Route path="/goods" element={<GoodsPage />} />
        <Route path="/goods/new" element={<GoodsForm />} />
        <Route path="/goods/:id" element={<GoodsDetail />} />
        <Route path="/goods/:id/edit" element={<GoodsForm />} />
        {/* Old list page merged into /events ("Hosted by me" tab); keep deep links alive. */}
        <Route path="/hosted-events" element={<Navigate to="/events?tab=hosted" replace />} />
        <Route path="/hosted-events/new" element={<HostedEventForm />} />
        <Route path="/hosted-events/:id" element={<HostedEventDetail />} />
        <Route path="/hosted-events/:id/edit" element={<HostedEventForm />} />
        <Route path="/amenities" element={isOutsideStaff ? <NotFound /> : <AmenitiesPage />} />
        <Route path="/payments" element={isOutsideStaff ? <NotFound /> : <PaymentsPage isAdmin={isAdmin} />} />
        <Route path="/villas/:villaNumber" element={<VillaPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AppShell>
  );
}

function NotFound() {
  return (
    <div className="vs-notfound">
      <div className="vs-notfound-card">
        <div className="vs-notfound-code">404</div>
        <h1>Page not found</h1>
        <p>
          The page you're looking for doesn't exist, was moved, or the link
          you followed is no longer active.
        </p>
        <div className="vs-notfound-actions">
          <Link to="/" className="vs-notfound-primary">
            <HomeIcon size={15} /> Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}

function DocumentsPage({ isAdmin, canApprove }) {
  return (
    <div>
      <div className="vsa-page-head">
        <div>
          <h1>Documents</h1>
          <p className="vsa-page-subtitle">
            Browse community documents by category, search, or upload your own
          </p>
        </div>
      </div>
      <MemberDocuments isAdmin={isAdmin} canApprove={canApprove} />
    </div>
  );
}

function ShellHome({ isResident = false }) {
  return (
    <div className="vsa-shellhome">
      {isResident && <SosPanel mode="resident" />}
      <h1>Welcome back!</h1>
      <p>Use the sidebar to navigate. Browse Documents, check the Members directory, or view your Profile.</p>
    </div>
  );
}

export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [registerOpen, setRegisterOpen] = useState(false);
  const [currentUser, setCurrentUserRaw] = useState(() => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch (_) {
      return null;
    }
  });
  const setCurrentUser = (u) => {
    if (u) sessionStorage.removeItem("auth_error");
    setCurrentUserRaw(u);
  };

  useEffect(() => {
    const onAuthErr = () => {
      // Token invalidated server-side or expired; clear local user state
      // and route the user back to the public home page.
      setCurrentUser(null);
      if (window.location.hash && window.location.hash !== "#/") {
        window.location.hash = "#/";
      }
    };
    window.addEventListener("vs_auth_error", onAuthErr);
    return () => window.removeEventListener("vs_auth_error", onAuthErr);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
    sessionStorage.removeItem("auth_error");
    setCurrentUser(null);
    // Always send the user to the public home page on logout.
    if (window.location.hash && window.location.hash !== "#/") {
      window.location.hash = "#/";
    }
  };

  if (currentUser) {
    return (
      <AuthProvider>
        <Router>
          <UIToast />
          <PageViewTracker />
          <AuthenticatedTree
            user={currentUser}
            onLogout={handleLogout}
          />
        </Router>
      </AuthProvider>
    );
  }

  return (
    <Router>
      <UIToast />
      <PageViewTracker />
      <AuthErrorBanner />
      <header id="header">
        <div className="container">
          <div className="logo">
            <Link to="/">
              <img
                src={`${process.env.PUBLIC_URL || ""}/logo-green-gold.png`}
                alt="Sanjivini Connect"
              />
            </Link>
          </div>

          <button
            className={`menu-toggle ${menuOpen ? "active" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle navigation"
          >
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </button>

          <nav id="navbar" className={menuOpen ? "open" : ""}>
            <ul>
              <li>
                <button
                  className="vs-header-login-btn vs-header-register-btn"
                  onClick={() => setRegisterOpen(true)}
                >
                  Register
                </button>
                <button className="vs-header-login-btn" onClick={() => setLoginOpen(true)}>
                  Login
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      <LoginModal
        open={loginOpen}
        onClose={() => setLoginOpen(false)}
        onAuthenticated={(user) => setCurrentUser(user)}
        onSwitchToRegister={() => {
          setLoginOpen(false);
          setRegisterOpen(true);
        }}
      />
      <RegisterModal
        open={registerOpen}
        onClose={() => setRegisterOpen(false)}
        onAuthenticated={(user) => setCurrentUser(user)}
        onSwitchToLogin={() => setLoginOpen(true)}
      />

      <Routes>
        <Route path="/__designdocs__" element={<DesignDocs />} />
        <Route path="/" element={<Home />} />
        <Route path="/downloads" element={<Documents heading="Downloads" />} />
        <Route path="/documents" element={<Documents heading="Documents" />} />
        <Route path="/properties" element={<PropertiesBrowse />} />
        <Route path="/properties/:id" element={<PropertyDetail />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/new" element={<EventForm />} />
        <Route path="/events/:id" element={<EventDetail />} />
        <Route path="/events/:id/edit" element={<EventForm />} />
        <Route path="/carpools" element={<CarpoolsPage />} />
        <Route path="/carpools/:id" element={<CarpoolDetail />} />
        <Route path="/goods" element={<GoodsPage />} />
        <Route path="/goods/new" element={<GoodsForm />} />
        <Route path="/goods/:id" element={<GoodsDetail />} />
        <Route path="/goods/:id/edit" element={<GoodsForm />} />
        {/* Old list page merged into /events ("Hosted by me" tab); keep deep links alive. */}
        <Route path="/hosted-events" element={<Navigate to="/events?tab=hosted" replace />} />
        <Route path="/hosted-events/new" element={<HostedEventForm />} />
        <Route path="/hosted-events/:id" element={<HostedEventDetail />} />
        <Route path="/hosted-events/:id/edit" element={<HostedEventForm />} />
        <Route path="/checkin" element={<VisitorCheckInPage />} />
        <Route path="/checkin/:code" element={<VisitorCheckInPage />} />
        <Route path="/unsubscribe" element={<UnsubscribePage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
}
